"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "fastMemo", {
  enumerable: true,
  get: function () {
    return _fastMemo.fastMemo;
  }
});
var _fastMemo = require("./fastMemo");